// combatpro/views/RandomEncountersView.js
//
// Combat PRO - dedicated Random Encounter page (spec 7). A fast generator/bank page:
// the preset controls plus the 12 Random slots. It reuses the shared
// GeneratedFamilySection (same generator components/state/actions as the dashboard
// Random section). No deep editing is exposed here. No optional chaining. No em dash.

import React from 'react';
import GeneratedFamilySection from '../runtime/GeneratedFamilySection';

function RandomEncountersView() {
  return (
    <div className="vi-view cp-family-page" id="view-random-encounters">
      <div className="cp-family-head">
        <div>
          <h2>{'\ud83c\udfb2 Random Encounters'}</h2>
          <div className="cp-family-helper">The players went somewhere unexpected. Choose a few presets and generate an appropriate surprise fight in seconds. Every change saves automatically.</div>
        </div>
      </div>
      <GeneratedFamilySection family="random" />
    </div>
  );
}

export default RandomEncountersView;
